var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../config/frontend/nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/Base.jinja"] = require( "front/Base.jinja" );
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/Grid/Grid.jinja"] = require( "front/components/Grid/Grid.jinja" );
dependencies["front/components/TopNav/TopNav.jinja"] = require( "front/components/TopNav/TopNav.jinja" );
dependencies["front/components/MenuLeft/MenuLeft.jinja"] = require( "front/components/MenuLeft/MenuLeft.jinja" );
dependencies["front/components/Story/Story.jinja"] = require( "front/components/Story/Story.jinja" );




var shim = require("/app/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/pages/History/History.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/Base.jinja", true, "assets/app/front/pages/History/History.jinja", false, function(t_3,t_2) {
if(t_3) { cb(t_3); return; }
parentTemplate = t_2
for(var t_1 in parentTemplate.blocks) {
context.addBlock(t_1, parentTemplate.blocks[t_1]);
}
output += " \n\n";
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/pages/History/History.jinja", false, function(t_5,t_4) {
if(t_5) { cb(t_5); return; }
t_4.getExported(function(t_6,t_4) {
if(t_6) { cb(t_6); return; }
context.setVariable("macros", t_4);
output += " \n";
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/pages/History/History.jinja", false, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
t_7.getExported(function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
if(Object.prototype.hasOwnProperty.call(t_7, "svgSprite")) {
var t_10 = t_7.svgSprite;
} else {
cb(new Error("cannot import 'svgSprite'")); return;
}
context.setVariable("svgSprite", t_10);
output += " \n";
env.getTemplate("front/components/Grid/Grid.jinja", false, "assets/app/front/pages/History/History.jinja", false, function(t_12,t_11) {
if(t_12) { cb(t_12); return; }
t_11.getExported(function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
if(Object.prototype.hasOwnProperty.call(t_11, "Grid")) {
var t_14 = t_11.Grid;
} else {
cb(new Error("cannot import 'Grid'")); return;
}
context.setVariable("Grid", t_14);
output += " \n";
env.getTemplate("front/components/TopNav/TopNav.jinja", false, "assets/app/front/pages/History/History.jinja", false, function(t_16,t_15) {
if(t_16) { cb(t_16); return; }
t_15.getExported(function(t_17,t_15) {
if(t_17) { cb(t_17); return; }
if(Object.prototype.hasOwnProperty.call(t_15, "TopNav")) {
var t_18 = t_15.TopNav;
} else {
cb(new Error("cannot import 'TopNav'")); return;
}
context.setVariable("TopNav", t_18);
output += " \n";
env.getTemplate("front/components/MenuLeft/MenuLeft.jinja", false, "assets/app/front/pages/History/History.jinja", false, function(t_20,t_19) {
if(t_20) { cb(t_20); return; }
t_19.getExported(function(t_21,t_19) {
if(t_21) { cb(t_21); return; }
if(Object.prototype.hasOwnProperty.call(t_19, "MenuLeft")) {
var t_22 = t_19.MenuLeft;
} else {
cb(new Error("cannot import 'MenuLeft'")); return;
}
context.setVariable("MenuLeft", t_22);
output += " \n";
env.getTemplate("front/components/Story/Story.jinja", false, "assets/app/front/pages/History/History.jinja", false, function(t_24,t_23) {
if(t_24) { cb(t_24); return; }
t_23.getExported(function(t_25,t_23) {
if(t_25) { cb(t_25); return; }
if(Object.prototype.hasOwnProperty.call(t_23, "Story")) {
var t_26 = t_23.Story;
} else {
cb(new Error("cannot import 'Story'")); return;
}
context.setVariable("Story", t_26);
output += " \n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("title"))(env, context, frame, runtime, function(t_28,t_27) {
if(t_28) { cb(t_28); return; }
output += t_27;
output += "\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("ogtitle"))(env, context, frame, runtime, function(t_30,t_29) {
if(t_30) { cb(t_30); return; }
output += t_29;
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("topNav"))(env, context, frame, runtime, function(t_32,t_31) {
if(t_32) { cb(t_32); return; }
output += t_31;
output += " \n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("content"))(env, context, frame, runtime, function(t_34,t_33) {
if(t_34) { cb(t_34); return; }
output += t_33;
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("libs"))(env, context, frame, runtime, function(t_36,t_35) {
if(t_36) { cb(t_36); return; }
output += t_35;
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})})})})})})})})})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_title(env, context, frame, runtime, cb) {
var lineno = 9;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += " • ";
output += runtime.suppressValue((lineno = 9, colno = 24, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Компания"])), env.opts.autoescape);
output += ": ";
output += runtime.suppressValue((lineno = 9, colno = 45, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["История"])), env.opts.autoescape);
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_ogtitle(env, context, frame, runtime, cb) {
var lineno = 10;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += " • ";
output += runtime.suppressValue((lineno = 10, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Компания"])), env.opts.autoescape);
output += ": ";
output += runtime.suppressValue((lineno = 10, colno = 47, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["История"])), env.opts.autoescape);
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_topNav(env, context, frame, runtime, cb) {
var lineno = 12;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += runtime.suppressValue((lineno = 13, colno = 13, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "TopNav"), "TopNav", context, [runtime.makeKeywordArgs({"classes": "TopNav--fixed TopNav--history","currentUrl": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "request")),"path")})])), env.opts.autoescape);
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_content(env, context, frame, runtime, cb) {
var lineno = 16;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
output += "<div class=\"History\">\n        <div class=\"History-left\">\n            ";
output += runtime.suppressValue((lineno = 19, colno = 28, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "MenuLeft"), "MenuLeft", context, [runtime.makeKeywordArgs({"classes": "MenuLeft--history","subpage": "history","caller": (function (){var macro_t_37 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_38 = "";;
frame = frame.pop();
return new runtime.SafeString(t_38);
});
return macro_t_37;})()})])), env.opts.autoescape);
output += "\n        </div>\n\n        <div class=\"History-years\">\n            ";
var t_39;
t_39 = runtime.contextOrFrameLookup(context, frame, "None");
frame.set("previous_year", t_39, true);
if(frame.topLevel) {
context.setVariable("previous_year", t_39);
}
if(frame.topLevel) {
context.addExport("previous_year", t_39);
}
output += "\n\n            ";
frame = frame.push();
var t_42 = runtime.contextOrFrameLookup(context, frame, "historyStories");
if(t_42) {t_42 = runtime.fromIterator(t_42);
var t_41 = t_42.length;
for(var t_40=0; t_40 < t_42.length; t_40++) {
var t_43 = t_42[t_40];
frame.set("years", t_43);
frame.set("loop.index", t_40 + 1);
frame.set("loop.index0", t_40);
frame.set("loop.revindex", t_41 - t_40);
frame.set("loop.revindex0", t_41 - t_40 - 1);
frame.set("loop.first", t_40 === 0);
frame.set("loop.last", t_40 === t_41 - 1);
frame.set("loop.length", t_41);
if(runtime.memberLookup((t_43),"year") == runtime.contextOrFrameLookup(context, frame, "previous_year")) {
;
}
else {
output += "<a href=\"#";
output += runtime.suppressValue(runtime.memberLookup((t_43),"year"), env.opts.autoescape);
output += "\" data-year=\"";
output += runtime.suppressValue(runtime.memberLookup((t_43),"year"), env.opts.autoescape);
output += "\" class=\"History-yearLink\">";
output += runtime.suppressValue(runtime.memberLookup((t_43),"year"), env.opts.autoescape);
output += "</a>";
;
}
var t_44;
t_44 = runtime.memberLookup((t_43),"year");
frame.set("previous_year", t_44, true);
if(frame.topLevel) {
context.setVariable("previous_year", t_44);
}
if(frame.topLevel) {
context.addExport("previous_year", t_44);
}
;
}
}
frame = frame.pop();
output += "\n\n            <a href=\"#2006\" data-year=\"2006\" class=\"History-yearLink\">2006</a>\n        </div>\n        \n        <div class=\"History-right\">\n            <div class=\"History-header\">\n                <h1 class=\"History-title\">";
output += runtime.suppressValue((lineno = 38, colno = 46, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["История"])), env.opts.autoescape);
output += "</h1>\n                <div class=\"History-description\">\n                    ";
output += runtime.suppressValue(env.getFilter("safe").call(context, (lineno = 40, colno = 24, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Московская Пивоваренная Компания вышла на российский рынок в сентябре 2008 года. C&nbsp;тех пор мы радуем вас качественными напитками мирового уровня."]))), env.opts.autoescape);
output += "\n                </div>\n            </div>\n\n            <div class=\"History-list\">\n                ";
var t_45;
t_45 = runtime.contextOrFrameLookup(context, frame, "None");
frame.set("previous_year", t_45, true);
if(frame.topLevel) {
context.setVariable("previous_year", t_45);
}
if(frame.topLevel) {
context.addExport("previous_year", t_45);
}
output += "\n\n                ";
frame = frame.push();
var t_48 = runtime.contextOrFrameLookup(context, frame, "historyStories");
if(t_48) {t_48 = runtime.fromIterator(t_48);
var t_47 = t_48.length;
for(var t_46=0; t_46 < t_48.length; t_46++) {
var t_49 = t_48[t_46];
frame.set("years", t_49);
frame.set("loop.index", t_46 + 1);
frame.set("loop.index0", t_46);
frame.set("loop.revindex", t_47 - t_46);
frame.set("loop.revindex0", t_47 - t_46 - 1);
frame.set("loop.first", t_46 === 0);
frame.set("loop.last", t_46 === t_47 - 1);
frame.set("loop.length", t_47);
if(runtime.memberLookup((t_49),"year") == runtime.contextOrFrameLookup(context, frame, "previous_year")) {
;
}
else {
output += "<div class=\"History-listBlock\" data-animation=\"1\" data-animation-type=\"fade\" data-animation-state=\"initial\" data-animation-delay=\"0\">\n                            <h2 id=\"";
output += runtime.suppressValue(runtime.memberLookup((t_49),"year"), env.opts.autoescape);
output += "\" \n                                class=\"History-year\" \n                                data-year=\"";
output += runtime.suppressValue(runtime.memberLookup((t_49),"year"), env.opts.autoescape);
output += "\"><span>";
output += runtime.suppressValue(runtime.memberLookup((t_49),"year"), env.opts.autoescape);
output += "</span></h2>\n                            \n                            <div class=\"History-news\">\n                                ";
frame = frame.push();
var t_52 = runtime.contextOrFrameLookup(context, frame, "historyStories");
if(t_52) {t_52 = runtime.fromIterator(t_52);
var t_51 = t_52.length;
for(var t_50=0; t_50 < t_52.length; t_50++) {
var t_53 = t_52[t_50];
frame.set("story", t_53);
frame.set("loop.index", t_50 + 1);
frame.set("loop.index0", t_50);
frame.set("loop.revindex", t_51 - t_50);
frame.set("loop.revindex0", t_51 - t_50 - 1);
frame.set("loop.first", t_50 === 0);
frame.set("loop.last", t_50 === t_51 - 1);
frame.set("loop.length", t_51);
if(runtime.memberLookup((t_53),"year") == runtime.memberLookup((t_49),"year")) {
output += runtime.suppressValue((lineno = 58, colno = 48, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "Story"), "Story", context, [t_53])), env.opts.autoescape);
;
}
;
}
}
frame = frame.pop();
output += "\n                            </div>\n                        </div>";
;
}
var t_54;
t_54 = runtime.memberLookup((t_49),"year");
frame.set("previous_year", t_54, true);
if(frame.topLevel) {
context.setVariable("previous_year", t_54);
}
if(frame.topLevel) {
context.addExport("previous_year", t_54);
}
;
}
}
frame = frame.pop();
output += "\n\n                <div class=\"History-launchBlock\">\n                    <h2 id=\"2006\" class=\"History-year\" data-year=\"2006\"><span>2006</span></h2>\n                    \n                    <p class=\"History-launch\">\n                        ";
output += runtime.suppressValue((lineno = 71, colno = 28, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "_"), "_", context, ["Создание Московской Пивоваренной Компании. Начало строительства пивоваренного завода в городе Мытищи Московской области."])), env.opts.autoescape);
output += "\n                    </p>\n                </div>\n            </div>\n        </div>\n    </div>";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_libs(env, context, frame, runtime, cb) {
var lineno = 79;
var colno = 3;
var output = "";
try {
var frame = frame.push(true);
context.getSuper(env, "libs", b_libs, frame, runtime, function(t_55,hole_204) {
if(t_55) { cb(t_55); return; }
hole_204 = runtime.markSafe(hole_204);
output += "\n    ";
output += runtime.suppressValue(hole_204, env.opts.autoescape);
output += "\n\n    <script src=\"";
output += runtime.suppressValue((lineno = 82, colno = 26, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "static"), "static", context, ["js/lottie.min.js"])), env.opts.autoescape);
output += "\"></script>\n";
cb(null, output);
});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_title: b_title,
b_ogtitle: b_ogtitle,
b_topNav: b_topNav,
b_content: b_content,
b_libs: b_libs,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/pages/History/History.jinja"] , dependencies)